import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { ViewAddressList } from '../Checkout/viewAddressList';
import AppButton from '../../components/AppButton';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  hidden: {
    display: 'none',
  },
}));

Address.propTypes = {};

function Address(props) {
  const classes = useStyles();
  const match = useRouteMatch('/checkout/:section');
  const history = useHistory();

  const section = match.params.section;

  return (
    <React.Fragment>
      <Box className={clsx({ [classes.hidden]: section !== 'info' })}>
        <ViewAddressList />
      </Box>
      <Box display={'flex'} justifyContent={'flex-end'} className={clsx({ [classes.hidden]: section !== 'info' })}>
        <AppButton
          round
          disableElevation
          color="secondary"
          variant="contained"
          type={'submit'}
          onClick={() => {
            history.push('/checkout/delivery');
          }}
        >
          Continuar
        </AppButton>
      </Box>
    </React.Fragment>
  );
}

export default Address;
